import {
  getPossibleBodyHeight,
  sliceText,
} from '@Components/BigBrowse/BBCalculationsUtils';
import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { CardText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import { observer } from 'mobx-react-lite';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const MultiSectionSectionHeroSmall = observer(
  function MultiSectionSectionHeroSmall({
    item,
    onClick,
  }: GridCardMeshProps<PlaneTypes.Card_MultiSection_SectionHero_Small>) {
    const titleProps: CardTextProps = {
      text: item.data?.title ?? '',
      fontSize: 26,
      fontAsset: Assets.Font_Gilroy_Bold,
      anchorX: 'left',
      anchorY: 'bottom',
      textAlign: 'left',
      maxWidth: item.size.width - 20,
      position: {
        x: -item.size.width / 2 + 10,
        y:
          -item.size.height / 2 +
          10 +
          getPossibleBodyHeight(item.data?.body, item.data?.title),
      },
    };

    const bodyPros: CardTextProps = {
      text: sliceText(item.data?.body, 200) ?? '',
      fontSize: 14,
      fontAsset: Assets.Font_Gilroy_SemiBold,
      color: 'white',
      anchorX: 'left',
      anchorY: 'bottom',
      textAlign: 'left',
      maxWidth: item.size.width - 20,
      position: {
        x: -item.size.width / 2 + 10,
        y: -item.size.height / 2 + 10,
      },
    };

    return (
      <ProductCardRounded
        uniqueKey={item.key!}
        position={item.worldPosition}
        size={item.size.width}
        imageUrl={item.data?.imageUrl}
        transparencyColor={transparencyColors[item.type]}
        hoverDisabled
        onClick={onClick}
        isViewHero={item.data?.isViewHero}
      >
        <CardText {...titleProps} />
        <CardText {...bodyPros} />
      </ProductCardRounded>
    );
  }
);
